<template lang="pug">
v-container
  //- Popup Create Vaccine
  v-dialog(v-model="show_create", max-width="600")
    Provider
  //- Header
  v-row(align="center", justify="space-between")
    v-col(cols="12", sm="2")
      h2.secondary--text Proveedores
    v-col(cols="12", sm="2")
      v-btn(outlined, color="secondary", @click="createProvider") Añadir Proveedor
  v-divider
  //- List Vaccination
  Table(
    :loading="loading",
    :headers="headers",
    @edit="editProvider",
    @delete="eraseProvider",
    :items="provider.results",
    @getPage="getProviderPage",
    :pageCount="provider.links.last_page",
    :itemsPerPage="provider.links.per_page"
  )
</template>

<script>
import providerAPI from "@/api/providers";
import Table from "@/components/Table.vue";
import { mapState, mapGetters } from "vuex";
import Provider from "@/components/Provider";

export default {
  components: {
    Table,
    Provider,
  },
  async created() {
    if (!this.auth_token) {
      this.$router.push("/auth/login");
    }
    this.getProviderPage(1);
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      auth_token: (state) => state.auth.auth_token,
      provider: (state) => state.providers.providers,
    }),
    ...mapGetters({
      choices: "selectChoices",
    }),
  },
  data() {
    return {
      loading: false,
      show_create: false,
      headers: [
        { text: "Descripción", value: "description" },
        { text: "Correo", value: "email" },
        { text: "Dirección", value: "address" },
        { text: "Celular", value: "phone_number_mobile" },
        { text: "Telefono", value: "phone_number" },
        { text: "Ciudad", value: "city.name" },
        { text: "Estado", value: "state.name" },
        { text: "País", value: "country.name" },
        { text: "Actiones", value: "actions" },
      ],
      messages_error_or_empty: "No tienes proveedores registradas",
    };
  },
  methods: {
    createProvider() {
      this.show_create = true;
    },
    async getProviderPage(page) {
      this.loading = true;
      await this.$store.dispatch("providers/getProviders", {
        token: this.auth_token,
        page: page,
      });
      this.loading = false;
    },
    editProvider(provider) {
      this.$router.push(`/providers/${provider.id}`);
    },
    async eraseProvider(provider) {
      this.$swal({
        title: `¿Estas seguro de borrar al proveedor (${provider.description})?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.value) {
          const response = await providerAPI.deleteProvider(
            provider.id,
            this.auth_token
          );

          if (response.status) {
            this.$swal({
              title: `Proveedor Borrado`,
              icon: "success",
            });
            await this.$store.dispatch("providers/getProviders", {
              token: this.auth_token,
              page: 1,
            });
          } else {
            this.$swal({
              title: response.data,
              icon: "error",
            });
          }
        }
      });
    },
  },
};
</script>
